
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/access-denied",
      function () {
        return require("private-next-pages/access-denied.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/access-denied"])
      });
    }
  